import React, { useState, useEffect } from 'react'
import { Table, Panel, Checkbox, SelectPicker, Row, Col, FlexboxGrid } from 'rsuite'
import { budgetFormat } from '../../../utils/formatterUtil'
import EditNumberCell from '../../../components/cell/EditNumberCell'
import moment from 'moment'
import { cloneDeep } from 'lodash-es'
// import EditDateCell from '../../admin/cell/EditDateCell'
import EditTextCell from '../../admin/cell/EditTextCell'
import EditSelectCell from '../../../components/cell/EditSelectCell'
import EditDateCustomCell from '../../../components/cell/EditDateCustomCell'
import classNames from 'classnames'
import { isRequired, isValidators } from '../../../utils/ValidatorUtils'
import InputSelectForm from '../../../components/forms/input/InputSelectForm'
import InputForm from '../../../components/forms/input/InputForm'
import InputNumberForm from '../../../components/forms/input/InputNumberForm'
import InputDateForm from '../../../components/forms/input/InputDateForm'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import ManageDurableArticlesManageDetail from './ManageDurableArticlesManageDetail'
import ManageDurableArticlesManageType from './ManageDurableArticlesManageType'

export default function ManageDurableArticlesTable({
  schema,
  loading,
  isEdit = false,
  enableManage = false,
  enableSelect = false,
  isSendBackStep1 = false,
  Controller,
  register,
  control,
  errors,
  setValue,
  getValues,
  setError,
  clearErrors,
  selectClosureType = () => {},
  closureType,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const [tableData, setTableData] = useState([])
  const [closureTypes, setClosureTypes] = useState([])
  const [from, setFrom] = useState(schema?.from)

  const [countSelected, setCountSelected] = useState(0)
  const [isSelectAll, setIsSelectAll] = useState()
  const [checkedKeys, setCheckedKeys] = useState([])
  const [indeterminate, setIndeterminate] = useState(false)
  const [isRefash, setIsRefash] = useState(false)

  const styleHeaderCell = { whiteSpace: 'normal', wordBreak: 'break-word' }
  const fs = localStorage.getItem('fontSize')

  useEffect(() => {
    register('table', schema.values || [])
    setValue('table', schema.values || [])

    setTableData(schema.values || [])
    mapClosureTypes(schema.values || [])
  }, [schema.values])

  const mapClosureTypes = (datas) => {
    console.log('mapClosureTypes datas : ', datas)
    let cts = []

    datas.forEach((e) => {
      cts.push(e.closureType?.toString())
    })

    console.log('cts : ', cts)

    setClosureTypes([...new Set(cts)])
  }

  const onChangeCellValue = (index, value, key) => {
    let datas = cloneDeep(tableData)

    datas[index][key] = value

    // let closureTypes = []
    // datas.forEach((e) => {
    //   closureTypes.push(e[key]?.toString())
    // })

    // selectClosureType(closureTypes)

    setValue('table', datas || [])
    setTableData(datas)
  }

  const handleCheckAll = (value, checked) => {
    const checkedKeys = checked ? tableData.map((item) => item.id) : []

    mapClosureTypes(checked ? tableData : [])

    setCheckedKeys(checkedKeys)
    setCountSelected(checkedKeys.length)
    validCheked('MULTI', value, checked)
  }

  const handleCheck = (value, checked) => {
    const nextCheckedKeys = checked
      ? [...checkedKeys, value]
      : checkedKeys.filter((item) => item !== value)

    mapClosureTypes(tableData.filter((e) => nextCheckedKeys.includes(e.id)))
    setCheckedKeys(nextCheckedKeys)
    setCountSelected(nextCheckedKeys.length)
    validCheked('ONE', value, checked)
  }

  const validCheked = (type, data, checked) => {
    let datas = cloneDeep(tableData)
    // console.log('data ', data)
    // console.log('checked ', checked)

    if (type == 'ONE') {
      datas.map((item) => {
        if (data == item.id) {
          item.checked = checked
        }
      })
    }

    if (type == 'MULTI') {
      datas.map((item) => {
        item.checked = checked
      })
    }

    setTableData(datas)
    setValue('table', datas)
  }

  const onApplyToAllselectd = (data) => {
    console.log('onApplyToAllselectd data : ', data)

    let datas = cloneDeep(tableData)

    datas
      .filter((e) => checkedKeys?.includes(e.id))
      ?.forEach((e) => {
        switch (e.closureType) {
          case 1:
            e[from.reserveProject.name] = data[from.reserveProject.name]
            e[from.reserveProjectState.name] = data[from.reserveProjectState.name]
            break
          case 2:
            e[from.buyerName.name] = data[from.buyerName.name]
            e[from.salePrice.name] = data[from.salePrice.name]
            e[from.billIngDocNo.name] = data[from.billIngDocNo.name]
            e[from.billIngDate.name] = data[from.billIngDate.name]

            break
          case 3:
            e[from.donateToName.name] = data[from.donateToName.name]
            e[from.donateDocNo.name] = data[from.donateDocNo.name]
            e[from.donateDocDate.name] = data[from.donateDocDate.name]
            break
          case 4:
            e[from.transferredProject.name] = data[from.transferredProject.name]
            break
          case 5:
            e[from.destroyDate.name] = data[from.destroyDate.name]
            break
          case 6:
            e[from.exchangeOrg.name] = data[from.exchangeOrg.name]
            e[from.exchangeDate.name] = data[from.exchangeDate.name]
            break
          default:
            break
        }
      })

    setTableData(datas)
    setValue('table', datas)
    onRefash()
  }

  const onChangeTableValueAll = (value, key) => {
    let datas = cloneDeep(tableData)

    datas?.forEach((item) => {
      if (checkedKeys?.includes(item.id)) {
        item[key] = value
      }
    })

    setValue('table', datas)
    setTableData(datas)

    console.log('datas : ', datas)

    selectClosureType([...new Set(datas?.map((item) => item.closureType))])
    onRefash()
  }

  const onRefash = () => {
    setIsRefash(true)
    setTimeout(() => {
      setIsRefash(false)
    }, 50)
  }

  const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, ...props }) => {
    return (
      <Cell {...props} style={{ padding: 0 }}>
        <div style={{ lineHeight: '46px' }}>
          <Checkbox
            value={rowData[dataKey]}
            inline
            onChange={onChange}
            checked={checkedKeys.some((item) => item === rowData[dataKey])}
          />
          {props.rowIndex + 1}
        </div>
      </Cell>
    )
  }

  return (
    <>
      <Panel header={`รายการครุภัณฑ์ขอปิด`}>
        {countSelected > 0 && (
          <div style={{ marginTop: -10 }}>
            {isSendBackStep1 ? (
              <ManageDurableArticlesManageType
                schema={schema}
                onApply={(data) => {
                  onChangeTableValueAll(data[schema.closureType.name], schema.closureType.name)
                }}
              />
            ) : (
              <ManageDurableArticlesManageDetail
                schema={from}
                closureTypes={closureTypes}
                onApply={onApplyToAllselectd}
              />
            )}
          </div>
        )}

        {!isRefash && (
          <Table
            wordWrap
            //minHeight={50}
            autoHeight={tableData?.length <= 10}
            height={tableData?.length <= 10 ? undefined : 500}
            loading={loading}
            headerHeight={fs <= 15 ? undefined : fs < 16 ? 70 : fs <= 18 ? 75 : 80}
            data={tableData}
            //style={{ marginTop: '20px' }}
            bordered
            cellBordered
            shouldUpdateScroll={false}
          >
            <Column width={100} align="center">
              <HeaderCell style={{ padding: 0 }}>
                <div style={{ lineHeight: '40px' }}>
                  <Controller
                    name="chkRow"
                    control={control}
                    render={(props) => {
                      if (enableSelect) {
                        return (
                          <Checkbox
                            inline
                            checked={isSelectAll}
                            indeterminate={indeterminate}
                            onChange={(e, checked) => {
                              props.onChange(checked)
                              // console.log('checked ', checked)
                              setIsSelectAll(checked)
                              handleCheckAll(null, checked)
                            }}
                          >
                            <b>ลำดับ</b>
                          </Checkbox>
                        )
                      } else {
                        return <b>ลำดับ</b>
                      }
                    }}
                  />
                </div>
              </HeaderCell>
              {enableSelect ? (
                <CheckCell
                  dataKey="id"
                  checkedKeys={checkedKeys}
                  onChange={(value, checked) => {
                    console.log('checked ', checked)
                    setIsSelectAll(false)
                    handleCheck(value, checked)
                  }}
                />
              ) : (
                <Cell>
                  {(_, index) => {
                    return index + 1
                  }}
                </Cell>
              )}
            </Column>

            <Column width={200}>
              <HeaderCell style={styleHeaderCell}>รหัสครุภัณฑ์</HeaderCell>
              <Cell dataKey="assetCode" />
            </Column>

            <Column width={250} minWidth={250} flexGrow={1}>
              <HeaderCell>ชื่อครุภัณฑ์</HeaderCell>
              <Cell dataKey="assetName" />
            </Column>

            <Column width={230}>
              <HeaderCell>ประเภทครุภัณฑ์</HeaderCell>
              <Cell dataKey="assetType" />
            </Column>

            <Column width={120} align="right">
              <HeaderCell>ราคา/หน่วย</HeaderCell>
              <Cell>
                {(rowData) => {
                  return budgetFormat(rowData.unitPrice || 0)
                }}
              </Cell>
            </Column>

            {enableManage ? (
              <Column width={180} align="center">
                <HeaderCell>รูปแบบบริหารจัดการ</HeaderCell>
                <Cell>
                  {(rowData, index) => {
                    return (
                      <EditSelectCell
                        id={`${schema.closureType.name}_${rowData.id}`}
                        //id={`table[${index}].${schema.activity.name}`}
                        rowData={rowData}
                        defaultValue={rowData.closureType?.toString()}
                        rowSchema={schema.closureType}
                        dataKey={schema.closureType.name}
                        register={register}
                        control={control}
                        errors={errors}
                        isEdit={enableManage}
                        cleanable={false}
                        searchable={true}
                        onChangeCell={(value) => {
                          onChangeCellValue(
                            index,
                            value && parseInt(value),
                            schema.closureType.name,
                            rowData.id
                          )
                        }}
                      />
                    )
                  }}
                </Cell>
              </Column>
            ) : (
              <Column width={180} align="center">
                <HeaderCell>รูปแบบบริหารจัดการ</HeaderCell>
                <Cell dataKey="closureTypeName" />
              </Column>
            )}

            {from && (
              <Column width={800}>
                <HeaderCell>รายละเอียดการบริหารจัดการ</HeaderCell>
                <Cell>
                  {(rowData, index) => {
                    if (rowData.closureType == '1') {
                      return (
                        <Row>
                          {from.reserveProject &&
                            (isEdit || (!isEdit && rowData[from.reserveProject.name] != null)) && (
                              <Col xs={12} sm={12} md={12} lg={12}>
                                <p>
                                  {from.reserveProject.label} :{' '}
                                  {!isEdit ? rowData[from.reserveProject.name] || '-' : ''}
                                </p>
                                {isEdit && (
                                  <EditSelectCell
                                    id={`${from.reserveProject.name}_${rowData.id}`}
                                    rowData={rowData}
                                    rowSchema={from.reserveProject}
                                    dataKey={from.reserveProject.name}
                                    register={register}
                                    control={control}
                                    errors={errors}
                                    isEdit={isEdit}
                                    cleanable={true}
                                    searchable={true}
                                    onChangeCell={(value) =>
                                      onChangeCellValue(index, value, from.reserveProject.name)
                                    }
                                  />
                                )}
                              </Col>
                            )}

                          {from.reserveProjectState &&
                            (isEdit ||
                              (!isEdit && rowData[from.reserveProjectState.name] != null)) && (
                              <Col xs={12} sm={12} md={12} lg={12}>
                                <p>
                                  {from.reserveProjectState.label} :{' '}
                                  {!isEdit ? rowData[from.reserveProjectState.name] || '-' : ''}
                                </p>
                                {isEdit && (
                                  <EditTextCell
                                    id={`${from.reserveProjectState.name}_${rowData.id}`}
                                    rowData={rowData}
                                    dataKey={from.reserveProjectState.name}
                                    register={register}
                                    control={control}
                                    errors={errors}
                                    isEdit={isEdit}
                                    required={
                                      isRequired(from.reserveProjectState.validators)
                                        ? undefined
                                        : {}
                                    }
                                    styleSheet={{ marginTop: 8, textAlign: 'right' }}
                                    onChangeCell={(value) =>
                                      onChangeCellValue(index, value, from.reserveProjectState.name)
                                    }
                                  />
                                )}
                              </Col>
                            )}
                        </Row>
                      )
                    } else if (rowData.closureType == '2') {
                      return (
                        <Row>
                          {from?.buyerName && (
                            <Col xs={6} sm={6} md={6} lg={6}>
                              <p>
                                {from.buyerName.label || 'ขายให้กับ'} :{' '}
                                {!isEdit ? rowData[from.buyerName.name] || '-' : ''}
                              </p>
                              {isEdit && (
                                <EditTextCell
                                  id={`${from.buyerName.name}_${rowData.id}`}
                                  rowData={rowData}
                                  dataKey={from.buyerName.name}
                                  register={register}
                                  control={control}
                                  errors={errors}
                                  isEdit={isEdit}
                                  isBudgetFormat={true}
                                  required={isRequired(from.buyerName.validators) ? undefined : {}}
                                  styleSheet={{ marginTop: 8, textAlign: 'right' }}
                                  onChangeCell={(value) =>
                                    onChangeCellValue(index, value, from.buyerName.name)
                                  }
                                />
                              )}
                            </Col>
                          )}

                          {from.salePrice && (
                            <Col xs={6} sm={6} md={6} lg={6}>
                              <p>
                                {from.salePrice.label || 'ราคาที่ขาย'} :{' '}
                                {!isEdit ? budgetFormat(rowData[from.salePrice.name]) || '-' : ''}
                              </p>
                              {isEdit && (
                                <EditNumberCell
                                  id={`${from.salePrice.name}_${rowData.id}`}
                                  //id={`table[${index}].${from.expenseWithholding.name}`}
                                  rowData={rowData}
                                  dataKey={from.salePrice.name}
                                  register={register}
                                  control={control}
                                  errors={errors}
                                  isEdit={isEdit}
                                  // isRequired={true}
                                  isBudgetFormat={true}
                                  styleSheet={{ marginTop: 20, textAlign: 'right' }}
                                  onChangeCell={(value) =>
                                    onChangeCellValue(index, value, from.salePrice.name)
                                  }
                                />
                              )}
                            </Col>
                          )}

                          {from.billIngDocNo && (
                            <Col xs={6} sm={6} md={6} lg={6}>
                              <p>
                                {from.billIngDocNo.label || 'เลขที่ใบเสร็จรับเงิน'} :{' '}
                                {!isEdit ? rowData[from.billIngDocNo.name] || '-' : ''}
                              </p>
                              {isEdit && (
                                <EditTextCell
                                  id={`${from.billIngDocNo.name}_${rowData.id}`}
                                  //id={`table[${index}].${from.expenseWithholding.name}`}
                                  rowData={rowData}
                                  dataKey={from.billIngDocNo.name}
                                  register={register}
                                  control={control}
                                  errors={errors}
                                  isEdit={isEdit}
                                  isBudgetFormat={true}
                                  required={
                                    isRequired(from.billIngDocNo.validators) ? undefined : {}
                                  }
                                  styleSheet={{ marginTop: 8, textAlign: 'right' }}
                                  onChangeCell={(value) =>
                                    onChangeCellValue(index, value, from.billIngDocNo.name)
                                  }
                                />
                              )}
                            </Col>
                          )}

                          {from.billIngDate && (
                            <Col xs={6} sm={6} md={6} lg={6}>
                              <p>
                                {from.billIngDate.label || 'วันที่ในใบเสร็จ'} :{' '}
                                {!isEdit
                                  ? moment(rowData[from.billIngDate.name]).format('DD/MM/YYYY') ||
                                    '-'
                                  : ''}
                              </p>
                              {isEdit && (
                                <EditDateCustomCell
                                  id={`${from.billIngDate?.name}_${rowData.id}`}
                                  //id={`table[${index}].${from.voucherDate.name}`}
                                  rowData={{
                                    ...rowData,
                                    billIngDate: rowData.billIngDate
                                      ? moment(rowData.billIngDate).format('DD/MM/YYYY')
                                      : null,
                                  }}
                                  dataKey={from.billIngDate?.name}
                                  register={register}
                                  control={control}
                                  errors={errors}
                                  isEdit={isEdit}
                                  onChangeCell={(value) => {
                                    console.log('value ', value)
                                    onChangeCellValue(index, value, from.billIngDate.name)
                                  }}
                                />
                              )}
                            </Col>
                          )}
                        </Row>
                      )
                    } else if (rowData.closureType == '3') {
                      return (
                        <Row>
                          {from.donateToName && (
                            <Col xs={8} sm={8} md={8} lg={8}>
                              <p>
                                {from.donateToName.label || 'บริจาคให้กับหน่วยงาน'} :{' '}
                                {!isEdit ? rowData[from.donateToName.name] || '-' : ''}
                              </p>
                              {isEdit && (
                                <EditTextCell
                                  id={`${from.donateToName.name}_${rowData.id}`}
                                  rowData={rowData}
                                  dataKey={from.donateToName.name}
                                  register={register}
                                  control={control}
                                  errors={errors}
                                  isEdit={isEdit}
                                  isBudgetFormat={true}
                                  required={
                                    isRequired(from.donateToName.validators) ? undefined : {}
                                  }
                                  styleSheet={{ marginTop: 8, textAlign: 'right' }}
                                  onChangeCell={(value) =>
                                    onChangeCellValue(index, value, from.donateToName.name)
                                  }
                                />
                              )}
                            </Col>
                          )}

                          {from.donateDocNo && (
                            <Col xs={8} sm={8} md={8} lg={8}>
                              <p>
                                {from.donateDocNo.label || 'เลขที่เอกสารการบริจาค'} :{' '}
                                {!isEdit ? rowData[from.donateDocNo.name] || '-' : ''}
                              </p>
                              {isEdit && (
                                <EditTextCell
                                  id={`${from.donateDocNo.name}_${rowData.id}`}
                                  rowData={rowData}
                                  dataKey={from.donateDocNo.name}
                                  register={register}
                                  control={control}
                                  errors={errors}
                                  isEdit={isEdit}
                                  isBudgetFormat={true}
                                  required={
                                    isRequired(from.donateDocNo.validators) ? undefined : {}
                                  }
                                  styleSheet={{ marginTop: 8, textAlign: 'right' }}
                                  onChangeCell={(value) =>
                                    onChangeCellValue(index, value, from.donateDocNo.name)
                                  }
                                />
                              )}
                            </Col>
                          )}

                          {from.donateDocDate && (
                            <Col xs={8} sm={8} md={8} lg={8}>
                              <p>
                                {from.donateDocDate.label || 'วันที่บริจาค'} :{' '}
                                {!isEdit
                                  ? moment(rowData[from.donateDocDate.name]).format('DD/MM/YYYY') ||
                                    '-'
                                  : ''}
                              </p>
                              {isEdit && (
                                <EditDateCustomCell
                                  id={`${from.donateDocDate.name}_${rowData.id}`}
                                  rowData={{
                                    ...rowData,
                                    donateDocDate: rowData.donateDocDate
                                      ? moment(rowData.donateDocDate).format('DD/MM/YYYY')
                                      : null,
                                  }}
                                  dataKey={from.donateDocDate.name}
                                  register={register}
                                  control={control}
                                  errors={errors}
                                  isEdit={isEdit}
                                  onChangeCell={(value) =>
                                    onChangeCellValue(index, value, from.donateDocDate.name)
                                  }
                                />
                              )}
                            </Col>
                          )}
                        </Row>
                      )
                    } else if (rowData.closureType == '4') {
                      return (
                        <Row>
                          {from.transferredProject && (
                            <Col xs={24} sm={24} md={24} lg={24}>
                              <p>
                                {from.transferredProject.label || 'โครงการที่รับโอน'} :{' '}
                                {!isEdit ? rowData[from.transferredProject.name] || '-' : ''}
                              </p>
                              {isEdit && (
                                <EditSelectCell
                                  id={`${from.transferredProject.name}_${rowData.id}`}
                                  rowData={rowData}
                                  rowSchema={from.transferredProject}
                                  dataKey={from.transferredProject.name}
                                  register={register}
                                  control={control}
                                  errors={errors}
                                  isEdit={isEdit}
                                  cleanable={true}
                                  searchable={true}
                                  onChangeCell={(value) =>
                                    onChangeCellValue(index, value, from.transferredProject.name)
                                  }
                                />
                              )}
                            </Col>
                          )}
                        </Row>
                      )
                    } else if (rowData.closureType == '5') {
                      return (
                        <Row>
                          {from.destroyDate && (
                            <Col xs={24} sm={12} md={12} lg={12}>
                              <p>
                                {from.destroyDate.label || 'วันที่ดำเนินการ'} :{' '}
                                {!isEdit
                                  ? moment(rowData[from.destroyDate.name]).format('DD/MM/YYYY') ||
                                    '-'
                                  : ''}
                              </p>
                              {isEdit && (
                                <EditDateCustomCell
                                  id={`${from.destroyDate.name}_${rowData.id}`}
                                  rowData={{
                                    ...rowData,
                                    destroyDate: rowData.destroyDate
                                      ? moment(rowData.destroyDate).format('DD/MM/YYYY')
                                      : null,
                                  }}
                                  dataKey={from.destroyDate.name}
                                  register={register}
                                  control={control}
                                  errors={errors}
                                  isEdit={isEdit}
                                  onChangeCell={(value) =>
                                    onChangeCellValue(index, value, from.destroyDate.name)
                                  }
                                />
                              )}
                            </Col>
                          )}
                        </Row>
                      )
                    } else if (rowData.closureType == '6') {
                      return (
                        <Row>
                          {from.exchangeOrg && (
                            <Col xs={12} sm={12} md={12} lg={12}>
                              <p>
                                {from.exchangeOrg.label || 'หน่วยงานที่แลกเปลี่ยน'} :{' '}
                                {!isEdit ? rowData[from.exchangeOrg.name] || '-' : ''}
                              </p>
                              {isEdit && (
                                <EditTextCell
                                  id={`${from.exchangeOrg.name}_${rowData.id}`}
                                  rowData={rowData}
                                  dataKey={from.exchangeOrg.name}
                                  register={register}
                                  control={control}
                                  errors={errors}
                                  isEdit={isEdit}
                                  isBudgetFormat={true}
                                  required={
                                    isRequired(from.exchangeOrg.validators) ? undefined : {}
                                  }
                                  styleSheet={{ marginTop: 8 }}
                                  onChangeCell={(value) =>
                                    onChangeCellValue(index, value, from.exchangeOrg.name)
                                  }
                                />
                              )}
                            </Col>
                          )}

                          {from.exchangeDate && (
                            <Col xs={12} sm={12} md={12} lg={12}>
                              <p>
                                {from.exchangeDate.label || 'วันที่แลกเปลี่ยน'} :{' '}
                                {!isEdit
                                  ? moment(rowData[from.exchangeDate.name]).format('DD/MM/YYYY') ||
                                    '-'
                                  : ''}
                              </p>
                              {isEdit && (
                                <EditDateCustomCell
                                  id={`${from.exchangeDate.name}_${rowData.id}`}
                                  rowData={{
                                    ...rowData,
                                    exchangeDate: rowData.exchangeDate
                                      ? moment(rowData.exchangeDate).format('DD/MM/YYYY')
                                      : null,
                                  }}
                                  dataKey={from.exchangeDate.name}
                                  register={register}
                                  control={control}
                                  errors={errors}
                                  isEdit={isEdit}
                                  onChangeCell={(value) =>
                                    onChangeCellValue(index, value, from.exchangeDate.name)
                                  }
                                />
                              )}
                            </Col>
                          )}
                        </Row>
                      )
                    }
                  }}
                </Cell>
              </Column>
            )}
          </Table>
        )}
      </Panel>
    </>
  )
}
